import { ApiError, api } from '../lib/api.js';
import { el, mount, toast } from '../lib/dom.js';
import { navigate } from '../lib/router.js';

// The 429 body carries retry_after_ms; ApiError.message holds the raw body.
function retryAfterSeconds(body: string): number | null {
  try {
    const ms = JSON.parse(body)?.retry_after_ms;
    return typeof ms === 'number' ? Math.ceil(ms / 1000) : null;
  } catch {
    return null;
  }
}

export function renderLogin() {
  const pwd = el('input', {
    class: 'input',
    type: 'password',
    id: 'pwd',
    name: 'password',
    autocomplete: 'current-password',
    placeholder: 'Senha',
    inputMode: 'text',
  });

  const submit = el('button', { class: 'btn btn--primary btn--cta', type: 'submit' }, ['Entrar']);

  const form = el(
    'form',
    {
      class: 'stack stack--md',
      onsubmit: async (ev: Event) => {
        ev.preventDefault();
        submit.disabled = true;
        try {
          await api.post('/auth/login', { password: pwd.value });
          navigate('/');
        } catch (err) {
          if (err instanceof ApiError && err.status === 401) toast('Senha inválida');
          else if (err instanceof ApiError && err.status === 429) {
            const secs = retryAfterSeconds(err.message);
            toast(
              secs
                ? `Muitas tentativas. Aguarde ${secs}s.`
                : 'Muitas tentativas. Aguarde um pouco.',
            );
          } else if (err instanceof ApiError && err.status === 400) {
            toast('Senha precisa de pelo menos 12 caracteres.');
          } else toast('Erro ao entrar');
        } finally {
          submit.disabled = false;
        }
      },
    },
    [
      el('div', { class: 'field' }, [
        el('label', { class: 'field__label', htmlFor: 'pwd' }, ['Senha']),
        pwd,
      ]),
      submit,
    ],
  );

  mount(
    el('main', { class: 'view view--center' }, [
      el('div', { class: 'stack stack--lg' }, [
        el('header', { class: 'stack stack--sm' }, [
          el('span', { class: 'pill pill--accent' }, ['mefit']),
          el('h1', { class: 'h1' }, ['Bem-vindo']),
          el('p', { class: 'muted' }, ['Single-user. Sua senha protege o app.']),
        ]),
        form,
      ]),
    ]),
  );

  setTimeout(() => pwd.focus(), 50);
}
